import { ActionReducerMap } from '@ngrx/store';

import * as fromNgrxRouter from '@ngrx/router-store';
import * as fromRouter from './router.reducer';
import * as fromUser from './current-user.reducer';
import * as fromCustomer from './current-customer.reducer';

import * as fromFeatures from './features.reducer';
import { featuresKey } from './features.reducer';
import * as fromCompany from './company.reducer';
import * as fromContact from './contact.reducer';
import * as fromUi from './ui.reducer';
import * as fromNews from './news.reducer';
import * as fromVehicle from './vehicle.reducer';
import * as fromVehicleGroup from './vehicle-group.reducer';
import * as fromVehicleFilters from './vehicle-filters.reducer';
import * as fromScheduledReports from './scheduled-reports.reducer';
import * as fromEmployees from './employee.reducer';
import * as fromUserGroups from './employee-group.reducer';
import * as fromInvites from './invite.reducer';
import * as fromOperatorSchedules from './operator-schedules.reducer';
import * as fromRealtime from './realtime.reducer';
import * as fromVehicleSchedules from './vehicle-schedule.reducer';
import * as fromDvrSettings from './dvr-settings.reducer';
import * as fromCameras from '../../vehicles/store/reducers/camera.reducer';
import * as fromGroupPermissions from './group-permissions.reducer';
import * as fromMapSettings from './map-settings.reducer';
import * as fromLocationMap from '../../locations/store/reducers/map.reducer';
import * as fromLocationHistory from '../../locations/store/reducers/location-history.reducer';
import * as fromLocationFilters from '../../locations/store/reducers/location-filters.reducer';

export interface State {
  [fromUi.uiFeatureKey]: fromUi.State;
  router: fromNgrxRouter.RouterReducerState<fromRouter.RouterState>;
  currentUser: fromUser.State;
  currentCustomer: fromCustomer.State;
  [fromFeatures.featuresKey]: fromFeatures.State;
  company: fromCompany.State;
  contact: fromContact.State;
  [fromRealtime.realtimeFeatureKey]: fromRealtime.State;
  [fromNews.newsFeatureKey]: fromNews.State;
  [fromVehicle.vehiclesFeatureKey]: fromVehicle.State;
  [fromVehicleGroup.vehicleGroupsFeatureKey]: fromVehicleGroup.State;
  [fromVehicleFilters.vehicleFiltersFeatureKey]: fromVehicleFilters.State;
  [fromScheduledReports.scheduledReportsFeatureKey]: fromScheduledReports.State;
  [fromEmployees.employeesFeatureKey]: fromEmployees.State;
  [fromUserGroups.employeeGroupFeatureKey]: fromUserGroups.State;
  [fromInvites.invitesFeatureKey]: fromInvites.State;
  [fromOperatorSchedules.operatorSchedulesFeatureKey]: fromOperatorSchedules.State;
  [fromVehicleSchedules.key]: fromVehicleSchedules.State;
  [fromDvrSettings.key]: fromDvrSettings.State;
  [fromCameras.cameraFeatureKey]: fromCameras.State;
  [fromCameras.cameraFeatureKey]: fromCameras.State;
  [fromGroupPermissions.groupPermissionsFeatureKey]: fromGroupPermissions.State;
  [fromMapSettings.mapSettingsFeatureKey]: fromMapSettings.State;
  [fromLocationMap.locationFeatureKey]: fromLocationMap.State;
  [fromLocationHistory.locationHistoryFeatureKey]: fromLocationHistory.State;
  [fromLocationFilters.locationFiltersFeatureKey]: fromLocationFilters.State;
}

export const reducers: ActionReducerMap<State> = {
  [fromUi.uiFeatureKey]: fromUi.reducer,
  router: fromNgrxRouter.routerReducer,
  currentUser: fromUser.reducer,
  currentCustomer: fromCustomer.reducer,
  [featuresKey]: fromFeatures.reducer,
  company: fromCompany.reducer,
  contact: fromContact.reducer,
  [fromRealtime.realtimeFeatureKey]: fromRealtime.reducer,
  [fromNews.newsFeatureKey]: fromNews.reducer,
  [fromEmployees.employeesFeatureKey]: fromEmployees.reducer,
  [fromUserGroups.employeeGroupFeatureKey]: fromUserGroups.reducer,
  [fromInvites.invitesFeatureKey]: fromInvites.reducer,
  [fromVehicle.vehiclesFeatureKey]: fromVehicle.reducer,
  [fromVehicleGroup.vehicleGroupsFeatureKey]: fromVehicleGroup.reducer,
  [fromVehicleFilters.vehicleFiltersFeatureKey]: fromVehicleFilters.reducer,
  [fromVehicleSchedules.key]: fromVehicleSchedules.reducer,
  [fromScheduledReports.scheduledReportsFeatureKey]:
    fromScheduledReports.reducer,
  [fromOperatorSchedules.operatorSchedulesFeatureKey]:
    fromOperatorSchedules.reducer,
  [fromDvrSettings.key]: fromDvrSettings.reducer,
  [fromCameras.cameraFeatureKey]: fromCameras.reducer,
  [fromGroupPermissions.groupPermissionsFeatureKey]:
    fromGroupPermissions.reducer,
  [fromMapSettings.mapSettingsFeatureKey]: fromMapSettings.reducer,
  [fromLocationMap.locationFeatureKey]: fromLocationMap.reducer,
  [fromLocationHistory.locationHistoryFeatureKey]: fromLocationHistory.reducer,
  [fromLocationFilters.locationFiltersFeatureKey]: fromLocationFilters.reducer,
};
